export default __webpack_public_path__ + "static/media/clipboard_icon.68f30ab6.svg";